export * from './login.component';


// WEBPACK FOOTER //
// ./src/app/views/login/index.ts